export const LEAD_SECTORS = [
  { id: 'probound', label: 'ProBound', color: '#2F5E96' },
  { id: 'proepoxy', label: 'ProEpoxy', color: '#7A0B7A' },
  { id: 'prodecor', label: 'ProDecor', color: '#D5AB09' },
  { id: 'general',  label: 'General / Other', color: '#6B7280' },
];

export const SECTOR_BY_ID = Object.fromEntries(LEAD_SECTORS.map((s) => [s.id, s]));
